export default [
  {
    id: 1,
    title: "Site E-commerce",
    desc: "Un site responsive conçu avec React et Tailwind.",
    image: `${process.env.PUBLIC_URL}/assets/images/red-mouse.png`,
  },
  {
    id: 2,
    title: "Campagne Tiktok",
    desc: "Stratégie sociale augmentant l’engagement de 40%.",
    image: `${process.env.PUBLIC_URL}/assets/images/insta.png`,
  },
  {
    id: 3,
    title: "Audit Système",
    desc: "Optimisation d’un réseau d’entreprise.",
    image: `${process.env.PUBLIC_URL}/assets/images/cons.png`,
  },
];
